/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller from '@ember/controller';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import GoalState from '@linc-technologies/linced-common/enums/goal-state';
import { byKeys } from '@linc-technologies/linced-common/utils/arrays';

export default class GoalController extends Controller {
  @alias('model.goal')
  goal;

  @computed('model.states.[]')
  get learners() {
    let learners = [];
    this.get('model.states').forEach((state) => {
      let learner = state.get('person');
      // Add to learners array if it's the current state for the learner in question (and they are working on it)
      if (
        state.get('awarded') === GoalState.DEVELOPING &&
        state.id === this.findCurrentStateId(learner)
      ) {
        learners.push(learner);
      }
    });

    return learners;
  }

  findCurrentStateId(learner) {
    let states = this.get('model.states').filter(
      (state) => state.person.id === learner.get('id'),
    );
    if (states && states.length) {
      return states.sort(byKeys('createTime')).at(-1)?.id;
    }

    return null;
  }
}
